export const navLinks = [
  { label: "最新入口", href: "#entrances" },
  { label: "访问指南", href: "#guide" },
  { label: "失效排查", href: "#issues" },
  { label: "热播合集", href: "#collections" },
  { label: "更新日志", href: "#updates" },
  { label: "常见问题", href: "#faq" },
];

export const entranceList = [
  {
    id: "line-main",
    name: "久久视频 · 官方主线路",
    domain: "jjsp-main.com",
    desc: "官方主站地址，播放流畅、资源更新最及时，日常优先使用这一条。",
    status: "畅通",
    latency: "18ms",
    type: "主线路",
  },
  {
    id: "line-two",
    name: "久久视频 · 备用线路二",
    domain: "jjsp-line2.com",
    desc: "主线路繁忙时自动切换，速度稳定，适合晚间高峰时段使用。",
    status: "畅通",
    latency: "34ms",
    type: "备用线路",
  },
  {
    id: "line-mobile",
    name: "久久视频 · 移动专线",
    domain: "m.jjsp-mobile.com",
    desc: "针对手机流量与移动网络优化，扫码或直接打开即可进入。",
    status: "畅通",
    latency: "41ms",
    type: "移动专线",
  },
  {
    id: "line-mirror",
    name: "久久视频 · 海外镜像入口",
    domain: "jjsp-mirror.net",
    desc: "面向海外用户的镜像站点，解决部分地域无法访问的问题。",
    status: "备用",
    latency: "96ms",
    type: "海外线路",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "挑选畅通的线路",
    desc: "在上方最新入口区，选择状态标记为「畅通」的线路，优先主线路。",
    icon: "ri-radar-line",
  },
  {
    step: "02",
    title: "复制并粘贴访问",
    desc: "点击复制地址，粘贴到浏览器地址栏打开，建议顺手收藏成书签。",
    icon: "ri-file-copy-line",
  },
  {
    step: "03",
    title: "失效就立刻换线",
    desc: "若提示无法访问或加载失败，返回本页切换到其他线路即可。",
    icon: "ri-refresh-line",
  },
  {
    step: "04",
    title: "收藏本页记名字",
    desc: "收藏本导航页并记住站点名称，地址变动时回来就能找到最新入口。",
    icon: "ri-bookmark-line",
  },
];

export const issueList = [
  {
    symptom: "打开后显示「无法访问」",
    cause: "原网址被网络屏蔽，或该域名临时失效。",
    solution: "返回本页，改用状态为「畅通」的其他线路重新打开。",
    icon: "ri-error-warning-line",
  },
  {
    symptom: "页面加载特别慢",
    cause: "高峰期线路拥堵，或本地网络出现波动。",
    solution: "切换到移动专线或备用线路，尽量避开晚间高峰。",
    icon: "ri-timer-line",
  },
  {
    symptom: "提示需要更新入口",
    cause: "官方已更换域名，旧地址停止维护。",
    solution: "以本页展示的最新地址为准，重新复制并收藏。",
    icon: "ri-link-unlink-m",
  },
  {
    symptom: "手机打不开、电脑能进",
    cause: "移动运营商对域名解析做了限制。",
    solution: "优先尝试移动专线，或在 Wi-Fi 与流量间切换后重试。",
    icon: "ri-smartphone-line",
  },
];

export const collectionList = [
  {
    id: "c1",
    title: "长街灯火",
    category: "都市",
    summary: "小城青年的十年创业与爱情，节奏紧凑，适合一口气看完的都市群像剧。",
    tags: ["都市", "情感", "群像"],
    meta: "全 32 集 · 已完结",
  },
  {
    id: "c2",
    title: "雾港疑云",
    category: "悬疑",
    summary: "连续失踪案牵出港口多年旧案，双线叙事层层反转，悬疑爱好者必追。",
    tags: ["悬疑", "刑侦", "反转"],
    meta: "全 24 集 · 已完结",
  },
  {
    id: "c3",
    title: "山河落雪时",
    category: "古装",
    summary: "家国与传奇交织的古装大剧，服化道考究，长线剧情越看越上头。",
    tags: ["古装", "权谋", "正剧"],
    meta: "更新至 46 集",
  },
  {
    id: "c4",
    title: "星轨之外",
    category: "科幻",
    summary: "近未来太空探索题材，硬核设定搭配人性抉择，科幻迷口碑之作。",
    tags: ["科幻", "太空", "硬核"],
    meta: "全 18 集 · 已完结",
  },
  {
    id: "c5",
    title: "归途列车",
    category: "都市",
    summary: "一列返乡列车上的百态人生，多组人物故事交汇，温暖又真实。",
    tags: ["都市", "温情", "群像"],
    meta: "全 20 集 · 已完结",
  },
  {
    id: "c6",
    title: "无声证词",
    category: "悬疑",
    summary: "以法医视角切入的冷案系列，细节推理扎实，适合周末连看。",
    tags: ["悬疑", "推理", "单元剧"],
    meta: "更新至 12 集",
  },
  {
    id: "c7",
    title: "锦绣长安",
    category: "古装",
    summary: "盛唐市井与朝堂风云交错，画面美学在线，适合喜欢历史氛围的观众。",
    tags: ["古装", "历史", "美学"],
    meta: "全 40 集 · 已完结",
  },
  {
    id: "c8",
    title: "数据迷宫",
    category: "科幻",
    summary: "人工智能觉醒之后的世界，悬念与哲思并重，篇幅短小精悍。",
    tags: ["科幻", "AI", "烧脑"],
    meta: "全 12 集 · 已完结",
  },
];

export const updateList = [
  {
    date: "2026-10-10",
    title: "主线路域名完成更新",
    summary: "原主线路已迁移至新域名，访问速度明显提升，建议改用新地址。",
    tag: "线路变更",
  },
  {
    date: "2026-10-06",
    title: "新增一条移动专线",
    summary: "针对移动端网络新增专线，缓解手机端访问缓慢的问题。",
    tag: "新增线路",
  },
  {
    date: "2026-09-28",
    title: "海外镜像完成例行维护",
    summary: "海外镜像站点完成维护升级，连接稳定性进一步提高。",
    tag: "节点维护",
  },
  {
    date: "2026-09-15",
    title: "备用线路带宽扩容",
    summary: "备用线路带宽扩容完成，高峰期的拥堵情况有所改善。",
    tag: "带宽升级",
  },
  {
    date: "2026-09-02",
    title: "入口导航页重新整理",
    summary: "重新梳理入口导航页面结构，方便快速找到最新可用地址。",
    tag: "站点公告",
  },
];

export const faqList = [
  {
    q: "久久视频的官网地址是哪一个？",
    a: "官方地址会不定期更换，请以本页「最新可用入口」中状态标记为「畅通」的线路为准，并建议收藏本页，方便随时回来获取最新地址。",
  },
  {
    q: "为什么原来能打开的网址打不开了？",
    a: "网址失效通常是因为域名更换，或所在网络对原地址做了限制访问。回到本页切换到其他线路即可继续访问。",
  },
  {
    q: "访问时提示需要更新入口怎么办？",
    a: "这说明当前使用的地址已经停止维护，请回到本页使用最新展示的线路重新打开，并更新你的书签。",
  },
  {
    q: "手机上打不开，有什么办法？",
    a: "可以优先尝试「移动专线」，也可以在 Wi-Fi 与移动数据之间切换后再试一次，通常就能解决。",
  },
  {
    q: "本站需要注册或者付费吗？",
    a: "本页面只提供地址导航与访问指引，不涉及注册、登录或任何付费项目，可以放心浏览。",
  },
  {
    q: "怎样第一时间知道最新地址？",
    a: "建议收藏本页并留意「线路更新日志」分区，地址发生变动时会第一时间在这里更新说明。",
  },
];